// extracted by mini-css-extract-plugin
export default {"rodape":"rodape_rodape__VhmcL","rodape__social":"rodape_rodape__social__rXS70"};